import { getMaxPriceRange } from '@wellbeingxltd/fe-lib/helpers'
import { ACTIONS } from 'actions/resource'
import { ORDERING_STAGES } from 'components/pages/Resource/ResourceBooking/utils'

export const initialState = {
    appState: {
        filterResourcesLoading: false,
        resourceLoading: false,
        resourcesLoading: false,
        resourcesLoaded: false,
        recommendedResourcesLoading: false,
        topResourcesLoaded: false,
        getTopResourcesLoading: false,
        getTopResourcesError: null,
        bookingState: ORDERING_STAGES.GET_PRICE,
        getResourcesError: null,
        getResourceError: null,
        getRecommendedResourcesError: null,
        getInHouseBenefitsError: null,
        getResourcePublicError: null,
    },
    database: {
        resource: {
            productsV2: [],
        },
        resourceList: [],
        recommendedResources: [],
        inHouseBenefits: [],
        inHouseBenefitsFetching: true,
        topResources: {
            byMH: [],
            byUsage: [],
            whatsNew: [],
        },
        filteredResources: [],
    },
    filters: {
        participants: '',
        pillar: '',
        poundsHigh: 0,
        poundsLow: 0,
        sortBy: 'featured',
        byText: false,
        searchedText: '',
        tags: {
            available: [],
            selected: '',
        },
        type: '',
    },
}

const hasPillarChanged = (filter, oldFilters) => (filter.name !== 'pillar' ? false : filter.value !== oldFilters.pillar)

const resourceReducer = (state = initialState, action) => {
    const { database, appState, filters } = state
    let newDatabase = { ...database }
    switch (action.type) {
        case ACTIONS.CHANGE_FILTERS: {
            // action.filter: {name, value}
            const { filter } = action
            const newFilters = { ...filters }
            if (filter.name === 'text') {
                return {
                    ...state,
                    filters: {
                        ...newFilters,
                        byText: filter.value,
                    },
                }
            }
            if (filter.name === 'searchedText') {
                return {
                    ...state,
                    filters: {
                        ...newFilters,
                        searchedText: filter.value,
                    },
                }
            }
            if (hasPillarChanged(filter, filters)) {
                newFilters.tags = { ...newFilters.tags, selected: '' }
            }

            return {
                ...state,
                filters: {
                    ...newFilters,
                    [action.filter.name]: action.filter.value,
                },
            }
        }
        case ACTIONS.CLEAR_FILTERS: {
            // Clear filters from sidebar
            const { poundsHigh, poundsLow } = getMaxPriceRange(database.resourceList)
            return { ...state, filters: { ...state.filters, participants: '', poundsHigh, poundsLow, sortBy: 'featured', type: '' } }
        }

        case ACTIONS.GET_RESOURCES.START:
            return {
                ...state,
                appState: { ...appState, resourcesLoading: true },
            }
        case ACTIONS.GET_RESOURCES.SUCCESS:
            const resourceList = []
            let resourceIndex = 0
            action.data.forEach(resource => {
                try {
                    resourceList[resourceIndex] = resource
                    resourceList[resourceIndex].productsV2 = resource.productsV2.sort((a, b) => parseFloat(a.priceFinal) - parseFloat(b.priceFinal))
                    resourceIndex += 1
                } catch (e) {
                    resourceList[resourceIndex] = resource
                    resourceIndex += 1
                }
            })
            newDatabase.resourceList = resourceList

            const { poundsHigh, poundsLow } = getMaxPriceRange(resourceList)
            return {
                ...state,
                appState: { ...appState, resourcesLoaded: true, resourcesLoading: false, getResourcesError: null },
                database: newDatabase,
                // Set high and low price intofilters
                filters: { ...state.filters, poundsHigh, poundsLow },
            }

        case ACTIONS.GET_RESOURCES.FAILURE:
            return { ...state, getResourcesError: action.error }

        case ACTIONS.GET_FILTERED_RESOURCES.START:
            return {
                ...state,
                appState: { ...appState, filterResourcesLoading: true },
            }
        case ACTIONS.GET_FILTERED_RESOURCES.SUCCESS:
            return {
                ...state,
                appState: {
                    ...appState,
                    filterResourcesLoading: false,
                },
                database: {
                    ...database,
                    filteredResources: action.data.items
                        .map(el => database.resourceList.find(resource => resource.resourceId === el.resourceId))
                        .filter(el => el),
                },
            }
        case ACTIONS.GET_FILTERED_RESOURCES.FAILURE:
            return { ...state, getResourcesError: action.error }

        case ACTIONS.CLEAN_FILTERED_RESOURCES:
            return {
                ...state,
                database: {
                    ...state.database,
                    filteredResources: [],
                },
            }

        case ACTIONS.GET_RECOMMENDED_RESOURCES.START:
            return {
                ...state,
                appState: { ...appState, recommendedResourcesLoading: true },
            }
        case ACTIONS.GET_RECOMMENDED_RESOURCES.SUCCESS:
            return {
                ...state,
                appState: { ...appState, getRecommendedResourcesError: null, recommendedResourcesLoading: false },
                database: { ...database, recommendedResources: action.data },
            }
        case ACTIONS.GET_RECOMMENDED_RESOURCES.FAILURE:
            return {
                ...state,
                appState: { ...appState, getRecommendedResourcesError: action.error, recommendedResourcesLoading: false },
            }

        case ACTIONS.GET_IN_HOUSE_BENEFITS.START:
            return {
                ...state,
                database: { ...database, inHouseBenefitsFetching: true },
            }
        case ACTIONS.GET_IN_HOUSE_BENEFITS.SUCCESS:
            return {
                ...state,
                appState: { ...appState, getInHouseBenefitsError: null },
                database: { ...database, inHouseBenefits: action.data, inHouseBenefitsFetching: false },
            }
        case ACTIONS.GET_IN_HOUSE_BENEFITS.FAILURE:
            return {
                ...state,
                appState: { ...appState, getInHouseBenefitsError: action.error },
                database: { ...database, inHouseBenefitsFetching: false },
            }

        case ACTIONS.GET_RESOURCE.START:
            return {
                ...state,
                appState: { ...appState, resourceLoading: true },
            }
        case ACTIONS.GET_RESOURCE.SUCCESS:
            newDatabase.resource = { ...action.data }
            newDatabase.resource.productsV2 = newDatabase.resource.productsV2.sort((a, b) => parseFloat(a.priceFinal) - parseFloat(b.priceFinal))
            return {
                ...state,
                appState: { ...appState, resourceLoading: false, getResourceError: null },
                database: newDatabase,
            }
        case ACTIONS.GET_RESOURCE.FAILURE:
            return {
                ...state,
                appState: { ...appState, resourceLoading: false, getResourceError: action.error },
            }

        case ACTIONS.GET_RESOURCE_PUBLIC.START:
            return {
                ...state,
                appState: { ...appState, resourceLoading: true },
            }
        case ACTIONS.GET_RESOURCE_PUBLIC.SUCCESS:
            return {
                ...state,
                appState: { ...appState, resourceLoading: false, getResourcePublicError: null },
                database: { ...database, resource: { ...action.data } },
            }
        case ACTIONS.GET_RESOURCE_PUBLIC.FAILURE:
            return {
                ...state,
                appState: { ...appState, resourceLoading: false, getResourcePublicError: action.error },
            }

        case ACTIONS.CLEAN_RESOURCE:
            return {
                ...state,
                appState: { ...appState, resourceLoading: false },
                database: { ...database, resource: {} },
            }

        case ACTIONS.GET_TOP_RESOURCES.START:
            return {
                ...state,
                appState: { ...appState, getTopResourcesLoading: true },
            }
        case ACTIONS.GET_TOP_RESOURCES.SUCCESS:
            const topResources = action.data
            if (topResources) {
                topResources.byMH &&
                    topResources.byMH.forEach(({ productsV2 }) => productsV2.sort((a, b) => parseFloat(a.priceFinal) - parseFloat(b.priceFinal)))
                topResources.byUsage &&
                    topResources.byUsage.forEach(({ productsV2 }) => productsV2.sort((a, b) => parseFloat(a.priceFinal) - parseFloat(b.priceFinal)))
            }
            return {
                ...state,
                appState: { ...appState, getTopResourcesLoading: false, topResourcesLoaded: true, getTopResourcesError: null },
                database: { ...database, topResources },
            }
        case ACTIONS.GET_TOP_RESOURCES.FAILURE:
            return {
                ...state,
                appState: { ...appState, getTopResourcesLoading: false, topResourcesLoaded: false, getTopResourcesError: action.error },
            }

        case ACTIONS.CHANGE_BOOKING_STATE:
            return {
                ...state,
                appState: {
                    ...state.appState,
                    bookingState: action.bookingState,
                },
            }

        default:
            return state
    }
}

export default resourceReducer
